/* ================================================== */
/*  MOBILE MENU
/* ================================================== */

$(document).ready(function(){

	var mobileMenu     = $('#layout--navigation--mobile'),
		menuSections   = $('.menu--sections', mobileMenu),
		duration       = 600,
		easing         = 'easeInOutQuad';

	// Add / remove « open » class
	$('#menu-trigger').click(function(){
		$('.hamburger', mobileMenu).toggleClass('hamburger--open');
		$(mobileMenu).toggleClass('open');
		$(menuSections).slideFadeToggle(duration, easing);
	});

	$('a', menuSections).click(function(event){
		event.preventDefault;

		console.log($(this).attr('href'));
		
		$(menuSections).slideFadeToggle(duration, easing);
		$('.hamburger').removeClass('hamburger--open');
		mobileMenu.removeClass('open');

		setTimeout(function(){
			// window.location.href = $(this).attr('href');
		}, 1200);
	});

	$('h1', mobileMenu).click(function(){
		if ($('.hamburger', mobileMenu).hasClass('hamburger--open')){
			$(menuSections).slideFadeToggle(duration, easing);
			$('.hamburger', mobileMenu).removeClass('hamburger--open');
		}
	});

});